var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"fsr-button",class:{
        disableClick: _vm.disabled,
        disableColor: _vm.myDisableColor,
      },on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('img',{attrs:{"src":require(("@/assets/" + _vm.icon + ".svg")),"alt":"Navigate","width":_vm.width,"height":_vm.height}}),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }